module.exports = "pegasus_template/assets/themelp1/basic/104.png";